import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_v_btn = _resolveComponent("v-btn")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-4" }, "Thank you for the information.", -1)),
    _createVNode(_component_v_btn, {
      disabled: !_ctx.token,
      onClick: _ctx.changeData
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("Change data", -1)
      ]))]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}